import React from 'react';
import EditableChart from './EditableChart';
import PublishedChart from './PublishedChart';

function CustomPivotChart({
  data,
  meta,
  configuration,
  publishing = false,
  isSharedWebpage = false,
  isDashboardPanel = false,
}) {
  const { chartType } = configuration;
  meta = { ...meta, publishing };

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
      }}
    >
      {!publishing && (
        <EditableChart
          data={data}
          meta={meta}
          configuration={configuration}
          chartType={chartType}
        />
      )}

      {publishing && (
        <PublishedChart
          data={data}
          meta={meta}
          configuration={configuration}
          chartType={chartType}
          dynamicSizing={isSharedWebpage || isDashboardPanel}
        />
      )}
    </div>
  );
}

export default CustomPivotChart;
